// 保留小数点
function setNumberFixed (number, fixedNumber = 2) {
  if (!number) { return number }
  return number.toFixed(fixedNumber)
}

export {
  setNumberFixed
}
